export const ALLOWED_LOCATIONS: { [key: string]: boolean } = {
  "Greater Vancouver": true,
};

export const MAX_LTV = 0.9;
export const MAX_FRACTION_DOWNPAYMENT = 0.4;
export const MINIMUM_LOAN_AMOUNT = 100000;
export const MINIMUM_PROPERTY_AMOUNT = 250000;
export const INTEREST_RATE_SECOND_MORTGAGE = 6.17;
export const INTEREST_RATE_FIRST_MORTGAGE = 4.0;
export const NUMBER_OF_PAYMENTS = 300; // 25 years
export const LENDING_FEE = 0.04;
export const LTV_BEFORE_ALERT = 0.485;
